import type { ReactElement } from 'react';
import { useSupplierSettingsQuery } from '@/entities/supplier-setting';
import { SupplierSettingsForm } from '@/features/settings/supplier';
import { ContentCard, EmptyState } from '@/shared/ui';

export const SupplierSettingsPanel = (): ReactElement => {
  const query = useSupplierSettingsQuery();
  if (query.isPending) return <EmptyState>사업자·입금 계좌 설정을 불러오는 중…</EmptyState>;
  if (query.isError && !query.data)
    return (
      <EmptyState isError>
        {`사업자·입금 계좌 설정을 불러오지 못했습니다: ${query.error.message}`}{' '}
        <button type="button" className="underline" onClick={() => void query.refetch()}>
          다시 시도
        </button>
      </EmptyState>
    );
  return (
    <ContentCard title="사업자·입금 계좌">
      {query.isError && (
        <p role="alert" className="text-sm text-destructive">
          설정을 다시 불러오지 못했습니다.{' '}
          <button type="button" className="underline" onClick={() => void query.refetch()}>
            다시 시도
          </button>
        </p>
      )}
      <SupplierSettingsForm settings={query.data} />
    </ContentCard>
  );
};
